import React from 'react';
import { Tabs } from 'antd';
import './index.css';
import khd_popup_bg from "../../static/imgs/khd_popup_bg.png";
import xzkhd_ic from "../../static/imgs/xzkhd_ic.png";
import QRCode from 'qrcode.react';
import http from '../../http/http';

import {
  CloseOutlined
} from '@ant-design/icons';

const { TabPane } = Tabs;

class Download extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false
    }
  }
  render () {
    return (
      <div className='download_index_wrap' style={{ display: this.state.show ? "flex" : "none" }} onClick={this.closeDownload.bind(this)}>
        <div className="download_content download-content-width download-content-height" onClick={this.contentClick.bind(this)}>
          <div className="header">
            <img src={khd_popup_bg}></img>
            <div className="title">赛百UI客户端</div>
            <CloseOutlined style={{ position: "absolute", right: "10px", top: "10px", width: "18px", height: "18px", color: "white", cursor: "pointer" }} onClick={this.closeDownload.bind(this)} />
            <img className="logo" src={xzkhd_ic}></img>
          </div>
          <div className="tab_content">
            <QRCode className="code" size={100} value={http.hostUrl + http.contextName + "/pages/download.html"} />
            <div className="text">请扫描上方二维码进行下载</div>
          </div>
        </div>
      </div>
    );
  }
  contentClick (e) {
    e.stopPropagation();
  }
  tabChange (key) {
    console.log(key);
  }
  downloadBtnClick () {
    console.log("产品下载");
  }
  closeDownload (e) {
    e.stopPropagation();
    this.setState({
      show: false
    });
  }
  showDownload () {
    this.setState({
      show: true
    });
  }
}
export default Download;